import {useEffect, useState} from "react";
import {queries} from "shared/api/queries";
import Feature from "ol/Feature";
import {Point} from "ol/geom";
import {ShippingSearchParamKey, TShippingItem,} from "features/shipping/types";
import {useSearchParams} from "react-router-dom";
import {CLUSTER_GROUP_KEY} from "shared/lib/map.fns";
import {useDataAll} from "shared/hooks/useDataAll";

export function useShippings() {
  const [params] = useSearchParams();
  const [features, setFeatures] = useState<Feature[]>([]);
  const shouldFetchShippingData = !!params.get(ShippingSearchParamKey.designatedSectorCodes)?.length && (!!params.get(ShippingSearchParamKey.returnSellerUuids)?.length || !!params.get(ShippingSearchParamKey.pickupBatchUuids)?.length || !!params.get(ShippingSearchParamKey.shippingShopUuids)?.length);
  
  const {listData, error, mutate, isLoading} = useDataAll<TShippingItem>({
    url: shouldFetchShippingData ? queries.shipping.list : null, params: params.toString()
  })
  
  useEffect(() => {
    let features: Feature[] = [];
    if (listData && listData?.length > 0) {
      listData.forEach((shipping) => {
        if (shipping.address?.lng != null && shipping.address?.lat != null) {
          features.push(new Feature({
            [CLUSTER_GROUP_KEY]: shipping.designated_sector?.code,
            shipping,
            geometry: new Point([
              Number(shipping.address.lng), Number(shipping.address?.lat),
            ])
          }));
        }
      });
    }
    setFeatures(features);
  }, [listData]);
  
  return {
    features, isLoading, mutate, isError: error,
  };
}
